import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { useColorMode } from '@chakra-ui/react';
import { ArrowRightSmall, Xmark } from '@peacecover/icon';
import { openNewTab } from '@pocapan/shared/utils/UIUtils';
import { useHandleHistoryBack } from '@pocapan/shared/utils/useHandleHistoryBack';

const SelectAddCollectionMethodPage = () => {
  const handleHistoryBack = useHandleHistoryBack();
  const navigate = useNavigate();
  const { colorMode } = useColorMode();
  return (
    <div className="min-h-screen bg-pure-white dark:bg-background-dark pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]">
      <header className="px-[16px] py-[15px]">
        <button type="button" onClick={handleHistoryBack}>
          <Xmark size={24} className="text-text-main-lv1" />
        </button>
      </header>
      <div className="px-[24px]">
        <div className="flex flex-col gap-[14px] items-center py-[10px] mt-[20px]">
          <h1 className="text-text-main-lv1 text-[26px] font-bold leading-[31px]">
            {t('SelectAddCollectionMethodPage.title')}
          </h1>
          <p className="text-text-main-lv4 text-[15px] font-medium leading-[18px]">
            {t('SelectAddCollectionMethodPage.description')}
          </p>
        </div>
        <div className="mt-[149px] flex flex-col gap-[8px] items-center">
          <LinkCardItem
            title={t('SelectAddCollectionMethodPage.imageSearch.title')}
            description={t('SelectAddCollectionMethodPage.imageSearch.description')}
            onClick={() => {
              navigate('/image-search?origin=select-method', { replace: true });
            }}
            imageUrl={`/assets/collections/image_search_banner_${colorMode}.png`}
          />
          <LinkCardItem
            title={t('SelectAddCollectionMethodPage.collectedPhotoCards.title')}
            description={t('SelectAddCollectionMethodPage.collectedPhotoCards.description')}
            onClick={() => {
              navigate('/collections', { replace: true }); // 포카 추가 페이지에서 opener.postMessage 처리를 위해 네비게이션
              openNewTab('/collected-photo-cards/edit');
            }}
            imageUrl="/assets/collections/collected_photo_cards_banner.png"
          />
        </div>
      </div>
    </div>
  );
};

export default SelectAddCollectionMethodPage;

const LinkCardItem = ({
  title,
  description,
  onClick,
  imageUrl
}: {
  title: string;
  description: string;
  onClick: () => void;
  imageUrl: string;
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center justify-between p-[16px] bg-background-light dark:bg-background-elevated rounded-[20px] shadow-[0_0_3px_0_rgba(0,0,0,0.05),_0_0_10px_0_rgba(0,0,0,0.07)]"
    >
      <div className="flex items-center gap-[10px]">
        <div className="w-[81px] h-[86px] rounded-[12px] bg-secondary-light dark:bg-secondary-dark px-[10px] py-[15px]">
          <img src={imageUrl} alt="link card item" />
        </div>
        <div className="flex flex-col gap-[4px] items-start">
          <p className="text-text-main-lv2 text-[15px] font-semibold leading-[18px] whitespace-pre-line text-left">
            {title}
          </p>
          <p className="text-text-sub-lv1 text-[12px] font-medium leading-[14px] whitespace-pre-line text-left">
            {description}
          </p>
        </div>
      </div>
      <ArrowRightSmall size={24} className="text-text-main-lv3" />
    </button>
  );
};
